import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {DeleteHealthAppointments} from 'domain/usecases';
import {RemoteDeleteHealthAppointments} from 'data/usecases';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeDeleteHealthAppointments = (): DeleteHealthAppointments =>
	new RemoteDeleteHealthAppointments(
		makeBFFApiUrl(BookingFlowEndPoints.healthScheduledAppointments),
		makeAuthorizeHttpClientDecorator(),
	);
